"use client";
import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import { PrivacyPolicyData } from "./PrivacyPolicyData";
import CircleIcon from "@mui/icons-material/Circle";
import "./index.css";

const sectionCardSx = {
  borderRadius: "16px",
  padding: { xs: "1rem", sm: "1.25rem" },
  width: "100%",
  my: 2,
  display: "flex",
  gap: 1.5,
  alignItems: "flex-start",
  background:
    "linear-gradient(180deg, rgba(255, 255, 255, 0.98) 0%, rgba(246, 251, 248, 0.55) 100%)",
  border: "1px solid rgba(18, 53, 36, 0.1)",
  boxShadow: "0 8px 28px rgba(18, 53, 36, 0.08)",
};

const sectionHeadingSx = {
  margin: "0 0 0.5rem",
  color: "#123524",
  fontWeight: 700,
};

const subHeadingSx = {
  margin: "0.75rem 0 0.5rem",
  color: "#1f7a4d",
  fontWeight: 600,
};

const numeralBoxSx = {
  width: "2rem",
  color: "#1f7a4d",
  flexShrink: 0,
  fontWeight: 700,
};

const listBulletSx = {
  fontSize: "8px",
  marginTop: "4px",
  color: "#1f7a4d",
  verticalAlign: "middle",
};

const PrivacyPolicy = () => {
  return (
    <Box component="article" sx={{ pb: { xs: 10, sm: 2 } }}>
      <Grid
        container
        item
        xs={11}
        sm={10}
        md={9.5}
        lg={9.5}
        margin="auto"
        sx={{
          margin: { xs: "1rem auto 2rem", sm: "2rem auto" },
          maxWidth: "min(92%, 1220px)",
          "& .MuiTypography-body2": {
            color: "#123524",
            lineHeight: 1.65,
          },
        }}
      >
        <Typography
          variant="h4"
          component="h1"
          sx={{
            padding: { xs: "0 0 1.5rem", sm: "0 0 2rem" },
            fontWeight: 700,
            background:
              "linear-gradient(135deg, #123524 0%, #1f7a4d 55%, #1a6b42 100%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: "text",
          }}
        >
          {PrivacyPolicyData?.heading}
        </Typography>
        <Box sx={sectionCardSx}>
          <Box sx={numeralBoxSx}>
            <Typography variant="h5" component="span">
              1.
            </Typography>
          </Box>
          <Box
            sx={{
              width: "100%",
            }}
          >
            <Typography variant="h5" component="h2" sx={sectionHeadingSx}>
              Introduction
            </Typography>
            <Typography variant="body2">
              {PrivacyPolicyData?.introduction}
            </Typography>
          </Box>
        </Box>
        <Box sx={sectionCardSx}>
          <Box sx={numeralBoxSx}>
            <Typography variant="h5" component="span">
              2.
            </Typography>
          </Box>
          <Box
            sx={{
              width: "100%",
            }}
          >
            <Typography variant="h5" component="h2" sx={sectionHeadingSx}>
              Personal Data That We Collect
            </Typography>

            <Typography variant="body2">
              {PrivacyPolicyData.personalData[0]?.title}
            </Typography>
            <br />
            {PrivacyPolicyData.personalData[1]?.content?.map((item, index) => (
              <Typography
                variant="body2"
                key={index}
                sx={{ margin: "0.5rem 0px" }}
              >
                <span style={{ fontWeight: "bold" }}>{item.heading}</span>{" "}
                &nbsp;
                {item.content}
              </Typography>
            ))}
          </Box>
        </Box>
        <Box sx={sectionCardSx}>
          <Box sx={numeralBoxSx}>
            <Typography variant="h5" component="span">
              3.
            </Typography>
          </Box>
          <Box
            sx={{
              width: "100%",
            }}
          >
            <Typography variant="h5" component="h2" sx={sectionHeadingSx}>
              Facial Data That We Collect
            </Typography>

            <Typography variant="body2">
              {PrivacyPolicyData?.FacialData}
            </Typography>
          </Box>
        </Box>
        <Box sx={sectionCardSx}>
          <Box sx={numeralBoxSx}>
            <Typography variant="h5" component="span">
              4.
            </Typography>
          </Box>
          <Box
            sx={{
              width: "100%",
            }}
          >
            <Typography variant="h5" component="h2" sx={sectionHeadingSx}>
              Privacy Policy Details
            </Typography>
            <Typography
              variant="body2"
              sx={{
                fontStyle: "italic",
                padding: "0.5rem 0px 1rem",
                color: "#5e6d63",
              }}
            >
              Last updated on July 25, 2023
            </Typography>
            <Typography variant="body2">
              {PrivacyPolicyData?.privacyPolicy}
            </Typography>{" "}
            <br />
            <Typography variant="body2">
              {PrivacyPolicyData?.privacyPolicyParaTwo}
            </Typography>
            <Typography variant="h6" component="h3" sx={subHeadingSx}>
              Information We May Collect
            </Typography>
            {PrivacyPolicyData.information?.map((item, index) => (
              <Typography key={index} variant="body2">
                <CircleIcon sx={listBulletSx} />
                &nbsp; {item.content}
              </Typography>
            ))}
            <Typography variant="h6" component="h3" sx={subHeadingSx}>
              What We Do with the Information We Gather
            </Typography>
            <Typography variant="body2">
              {PrivacyPolicyData.whatWeDo[0].title}
            </Typography>
            <br />
            {PrivacyPolicyData?.whatWeDo[1]?.points?.map((item, index) => (
              <Typography key={index} variant="body2">
                <CircleIcon sx={listBulletSx} />
                &nbsp; {item.content}
              </Typography>
            ))}
            <Typography variant="h6" component="h3" sx={subHeadingSx}>Security</Typography>
            <Typography variant="body2">
              {PrivacyPolicyData.security}
            </Typography>
            <Typography variant="h6" component="h3" sx={subHeadingSx}>How We Use Cookies</Typography>
            <Typography variant="body2">{PrivacyPolicyData.cookies}</Typography>
            <br />
            <Typography variant="body2">
              {PrivacyPolicyData.cookiesParaTwo}
            </Typography>
            <br />
            <Typography variant="body2">
              {PrivacyPolicyData.cookiesParaThree}
            </Typography>
            <br />
            <Typography variant="body2">
              {PrivacyPolicyData.cookiesParaFour}
            </Typography>
            <Typography variant="h6" component="h3" sx={subHeadingSx}>
              Controlling Your Personal Information
            </Typography>
            <Typography variant="body2">
              {PrivacyPolicyData.personalInformation[0].title}
            </Typography>
            <br />
            <Typography variant="body2">
              <CircleIcon sx={listBulletSx} />
              &nbsp;{" "}
              {PrivacyPolicyData &&
              PrivacyPolicyData.personalInformation?.[1]?.points?.[0]?.one
                ? PrivacyPolicyData.personalInformation[1].points[0].one
                : ""}
            </Typography>
            {/* <br /> */}
            <Typography variant="body2">
              <CircleIcon sx={listBulletSx} />
              &nbsp;
              {PrivacyPolicyData &&
              PrivacyPolicyData.personalInformation?.[1]?.points?.[0]?.two
                ? PrivacyPolicyData.personalInformation[1].points[0].two
                : ""}
            </Typography>
            <br />
            <Typography variant="body2">
              {PrivacyPolicyData?.personalInformation[2]?.information}
            </Typography>
            <br />
            <Typography variant="body2">
              {PrivacyPolicyData?.personalInformation[3]?.informationNextPara}
            </Typography>
          </Box>
        </Box>
        <Box sx={sectionCardSx}>
          <Box sx={numeralBoxSx}>
            <Typography variant="h5" component="span">
              5.
            </Typography>
          </Box>
          <Box
            sx={{
              width: "100%",
            }}
          >
            <Typography variant="h5" component="h2" sx={sectionHeadingSx}>Terms & Conditions</Typography>
            <Typography
              variant="body2"
              sx={{
                fontStyle: "italic",
                padding: "0.5rem 0px 1rem",
                color: "#5e6d63",
              }}
            >
              Last updated on July 25, 2023
            </Typography>
            <Typography variant="body2">
              {PrivacyPolicyData?.Terms.paraOne}
            </Typography>
            <br />
            <Typography variant="body2">
              {PrivacyPolicyData?.Terms.paraTwo}
            </Typography>
            <br />

            <Typography variant="body2">
              {PrivacyPolicyData?.Terms.paraThree}
            </Typography>
            <Typography variant="h6" component="h3" sx={subHeadingSx}>
              The Use of This Website Is Subject to the Following Terms of Use:
            </Typography>
            {PrivacyPolicyData?.useTerms.map((item, index) => (
              <Typography key={index} variant="body2">
                <CircleIcon sx={listBulletSx} />
                &nbsp; {item.point}
              </Typography>
            ))}
            <br />
            <Typography variant="body2">
              {PrivacyPolicyData.useTermsDescription}
            </Typography>
          </Box>
        </Box>
        <Box sx={sectionCardSx}>
          <Box sx={numeralBoxSx}>
            <Typography variant="h5" component="span">
              6.
            </Typography>
          </Box>
          <Box
            sx={{
              width: "100%",
            }}
          >
            <Typography variant="h5" component="h2" sx={sectionHeadingSx}>Cancellation & Refund Policy</Typography>
            <Typography
              variant="body2"
              sx={{
                fontStyle: "italic",
                padding: "0.5rem 0px 1rem",
                color: "#5e6d63",
              }}
            >
              Last updated on July 26, 2023
            </Typography>
            <Typography variant="body2">
              {PrivacyPolicyData.cancellation[0].heading}
            </Typography>
            <br />
            {PrivacyPolicyData &&
              PrivacyPolicyData.cancellation[1]?.content &&
              PrivacyPolicyData?.cancellation[1]?.content.map((item, index) => (
                <Typography key={index} variant="body2">
                  <CircleIcon sx={listBulletSx} />
                  &nbsp; {item.points}
                </Typography>
              ))}
          </Box>
        </Box>
        <Box sx={sectionCardSx}>
          <Box sx={numeralBoxSx}>
            <Typography variant="h5" component="span">
              7.
            </Typography>
          </Box>
          <Box
            sx={{
              width: "100%",
            }}
          >
            <Typography variant="h5" component="h2" sx={sectionHeadingSx}>Contact Us</Typography>
            <Typography
              variant="body2"
              sx={{
                fontStyle: "italic",
                padding: "0.5rem 0px 1rem",
                color: "#5e6d63",
              }}
            >
              Last updated on July 26, 2023
            </Typography>
            <Typography variant="body2" sx={{ margin: "0.5rem 0px 1rem" }}>
              {PrivacyPolicyData.contactTitle}
            </Typography>
            {PrivacyPolicyData?.contact.map((item, index) => (
              <Typography key={index} variant="body2">
                {item.line}
              </Typography>
            ))}
          </Box>
        </Box>
        <Box sx={sectionCardSx}>
          <Box sx={numeralBoxSx}>
            <Typography variant="h5" component="span">
              8.
            </Typography>
          </Box>
          <Box
            sx={{
              width: "100%",
            }}
          >
            <Typography variant="h5" component="h2" sx={sectionHeadingSx}>Only for Service Providers</Typography>
            <Typography variant="body2">
              {PrivacyPolicyData?.serviceProvider}
            </Typography>
            <Typography variant="h6" component="h3" sx={subHeadingSx}>
              Expert Visits and Missing Items
            </Typography>
            {PrivacyPolicyData?.MissingItems.map((item, index) => (
              <Box key={index}>
                <Typography variant="body2">{item.points}</Typography>
                <br />
              </Box>
            ))}
          </Box>
        </Box>
        <Box sx={sectionCardSx}>
          <Box sx={numeralBoxSx}>
            <Typography variant="h5" component="span">
              9.
            </Typography>
          </Box>
          <Box
            sx={{
              width: "100%",
            }}
          >
            <Typography variant="h5" component="h2" sx={sectionHeadingSx}>Collection of Phone Number</Typography>
            <Typography variant="h6" component="h3" sx={subHeadingSx}>
              Privacy Policy Update - Collection of Phone Number
            </Typography>
            <Typography variant="body2">
              {PrivacyPolicyData?.collectionPN}
            </Typography>
            <Typography variant="h6" component="h3" sx={subHeadingSx}>Collection Purpose</Typography>
            <Typography variant="body2">
              {/* {PrivacyPolicyData?.collectionPurpose[0]?.title} */}
              {typeof PrivacyPolicyData?.collectionPurpose[0] === "object" &&
              !Array.isArray(PrivacyPolicyData?.collectionPurpose[0])
                ? PrivacyPolicyData.collectionPurpose[0]?.title
                : ""}
            </Typography>
            <br />
            {PrivacyPolicyData &&
              PrivacyPolicyData?.collectionPurpose[1] &&
              Array.isArray(PrivacyPolicyData?.collectionPurpose[1]) &&
              PrivacyPolicyData?.collectionPurpose[1].map(
                (item: any, index: any) => (
                  <Typography key={index} variant="body2">
                    <CircleIcon sx={listBulletSx} />
                    &nbsp;{" "}
                    <span style={{ fontWeight: "bold" }}>{item.heading}</span>
                    &nbsp; {item.points}
                  </Typography>
                )
              )}
            <Typography variant="h6" component="h3" sx={subHeadingSx}>
              Security and Confidentiality
            </Typography>
            <Typography variant="body2">
              {PrivacyPolicyData?.Confidentiality}
            </Typography>
            <Typography variant="h6" component="h3" sx={subHeadingSx}>
              Account deletion
            </Typography>
            <Typography variant="body2">
              {/* {PrivacyPolicyData?.AccountDelect[0]?.title} */}
              {PrivacyPolicyData?.AccountDelect?.[0] &&
              "title" in PrivacyPolicyData.AccountDelect[0]
                ? PrivacyPolicyData.AccountDelect[0].title
                : ""}
            </Typography>
            <br />
            {PrivacyPolicyData?.AccountDelect?.[1] &&
              Array.isArray(PrivacyPolicyData.AccountDelect[1]) &&
              PrivacyPolicyData.AccountDelect[1].map(
                (item: any, index: any) => (
                  <Typography key={index} variant="body2">
                    {item.points}
                  </Typography>
                )
              )}
          </Box>
        </Box>
      </Grid>
    </Box>
  );
};

export default PrivacyPolicy;
